import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.39 9.62C16.57 10 16.52 10.45 16.25 10.77L13.12 14.6C12.91 14.85 12.6 15 12.27 15C11.94 15 11.63 14.86 11.42 14.6L8.24996 10.81C7.97996 10.48 7.91996 10.03 8.09996 9.66C8.27996 9.28 8.66996 9.03 9.08996 9.03L15.39 9C15.81 9 16.2 9.24 16.38 9.62H16.39Z" fill={ fill || 'currentColor' }/>
    </svg>

);
